import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * Explains the search bar with a few example filters. Shown by the search's
 * help icon and by the tests page guide.
 *
 *   <fk-help href=${docsUrl('/api/fql/')}><fql-help></fql-help></fk-help>
 */
@customElement('fql-help')
export class FQLHelp extends LitElement {
  override render() {
    return html`
      <p>Find tests by name, or narrow them down with filters:</p>
      <dl>
        <dt><code>f:e2e</code></dt><dd>tests in the e2e folder</dd>
        <dt><code>#smoke</code></dt><dd>tests tagged smoke</dd>
        <dt><code>duration>1s</code></dt><dd>tests slower than a second</dd>
      </dl>
    `;
  }

  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--sl-spacing-x-small);
    }

    p, dl, dd {
      margin: 0;
    }

    dl {
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: baseline;
      gap: var(--sl-spacing-3x-small) var(--sl-spacing-small);
    }

    code {
      padding: 0 var(--sl-spacing-2x-small);
      border-radius: var(--sl-border-radius-small);
      background: var(--sl-color-primary-100);
      font-family: var(--sl-font-mono);
      font-size: 0.9em;
    }
  `;
}
